import { useNavigate } from "react-router-dom";
import { useApp } from "../lib/store";
import { ListPage } from "../components/ListPage";
import { Badge } from "../components/ui/badge";
import { fmtEur, fmtDate } from "../lib/api";
import { QUOTE_STATUS_COLORS } from "../lib/fields";
import { trackRecent } from "../components/Layout";

export default function Quotes() {
  const { t, isManager, plLabel } = useApp();
  const navigate = useNavigate();
  const columns = [
    { key: "quote_number", label: t("quote_number"), render: (r) => <span className="font-mono font-medium text-[#1B2A4A]">{r.quote_number} <span className="text-gray-400">v{r.version}</span></span> },
    { key: "account_name", label: t("account") },
    { key: "opportunity_name", label: t("opportunities"), render: (r) => <span className="text-gray-500 text-xs">{r.opportunity_name || "–"}</span> },
    { key: "status", label: t("status"), render: (r) => <Badge className={`${QUOTE_STATUS_COLORS[r.status] || ""} hover:bg-inherit`}>{plLabel("quote_statuses", r.status)}</Badge> },
    { key: "total", label: t("total"), align: "right", render: (r) => fmtEur(r.total, r.currency) },
    ...(isManager ? [{ key: "margin_pct", label: t("margin"), align: "right", render: (r) => `${r.margin_pct ?? "–"}%` }] : []),
    { key: "validity_date", label: t("validity"), render: (r) => fmtDate(r.validity_date) },
    { key: "owner_name", label: t("owner") },
  ];
  return (
    <ListPage module="quotes" titleKey="quotes" columns={columns}
      onRowClick={(r) => { trackRecent(r.quote_number, `/quotes/${r.id}`); navigate(`/quotes/${r.id}`); }} />
  );
}
